
import React from 'react';
import { MicOff, VideoOff, MonitorSmartphone } from 'lucide-react';

interface ParticipantStatusIndicatorsProps {
  isMuted: boolean;
  isVideoOff: boolean;
  isScreenSharing: boolean;
}

const ParticipantStatusIndicators: React.FC<ParticipantStatusIndicatorsProps> = ({ 
  isMuted,
  isVideoOff,
  isScreenSharing
}) => {
  return (
    <div className="absolute top-2 right-2 flex gap-1 z-30">
      {isScreenSharing && (
        <div className="bg-blue-500/20 p-1 rounded-full">
          <MonitorSmartphone className="h-3 w-3 text-blue-500" />
        </div>
      )}
      {isMuted && (
        <div className="bg-red-500/20 p-1 rounded-full">
          <MicOff className="h-3 w-3 text-red-500" />
        </div>
      )}
      {isVideoOff && (
        <div className="bg-red-500/20 p-1 rounded-full">
          <VideoOff className="h-3 w-3 text-red-500" />
        </div>
      )}
    </div>
  );
};

export default ParticipantStatusIndicators;
